import {
  MsdDto,
  MsdHandArmVibrationDto,
  MsdLiftingAnalysisDto,
} from "src/app/services/generatedApi";
import { defaultMsdData } from "./constants";

export const saveHandArmVibrationData = (
  currentMsdData: MsdDto | undefined,
  vibrationData: Partial<MsdHandArmVibrationDto>,
): MsdDto => {
  const baseData = currentMsdData || defaultMsdData;

  return {
    ...baseData,
    handArmVibration: {
      ...baseData.handArmVibration,
      ...vibrationData,
    },
  };
};

export const getHandArmVibrationData = (
  msdData: MsdDto | undefined,
): MsdHandArmVibrationDto => {
  return msdData?.handArmVibration || {};
};

export const saveLiftingAnalysisData = (
  currentMsdData: MsdDto | undefined,
  liftingData: Partial<MsdLiftingAnalysisDto>,
): MsdDto => {
  const baseData = currentMsdData || defaultMsdData;

  return {
    ...baseData,
    liftingAnalysis: {
      ...baseData.liftingAnalysis,
      ...liftingData,
    },
  };
};

export const getLiftingAnalysisData = (
  msdData: MsdDto | undefined,
): MsdLiftingAnalysisDto => {
  return msdData?.liftingAnalysis || {};
};

export const updateMsdAnalysisData = (
  currentMsdData: MsdDto | undefined,
  updates: {
    handArmVibration?: Partial<MsdHandArmVibrationDto>;
    liftingAnalysis?: Partial<MsdLiftingAnalysisDto>;
  },
): MsdDto => {
  let updatedData = currentMsdData || defaultMsdData;

  if (updates.handArmVibration) {
    updatedData = saveHandArmVibrationData(
      updatedData,
      updates.handArmVibration,
    );
  }

  if (updates.liftingAnalysis) {
    updatedData = saveLiftingAnalysisData(updatedData, updates.liftingAnalysis);
  }

  return updatedData;
};
